const version = require('@/assets/build.json').version

/**
 * Repository for application metadata (such as version)
 */
export default {
  // We specifically do not store the version in the state object as it should
  // always be whatever is in the build.json
  state: {},

  getters: {
    version: state => {
      return version
    }
  }
}
